module.exports = __webpack_public_path__ + "assets/img/chihuang140.d721385e.jpg";